import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { AppService } from 'src/app/app.service';
import {JsonCase, JsonCaseTongue, SimpleTongueDto, TaggerType} from 'src/model/dto';
import { ContentType, SeverityEnum, ToastMsg } from 'src/model/page';
import { TongueLocationSelectorComponent } from '../tongue-location-selector/tongue-location-selector.component';
import { Utility } from 'src/app/utility/Utility';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'tudi-case-tagging',
  templateUrl: './case-tagging.component.html',
  styleUrls: ['./case-tagging.component.scss']
})
export class CaseTaggingComponent {
  @ViewChild(TongueLocationSelectorComponent) tongueLocationSelector: TongueLocationSelectorComponent;
  @Input() patientCase: JsonCase;
  @Output() onUpdate: EventEmitter<JsonCase> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Output() onUpdateAndNext: EventEmitter<JsonCase> = new EventEmitter();

  typeOptions: SelectItem[] = [];
  tongues: {[key: number]: SimpleTongueDto[]} = {};
  selectedTongue: JsonCaseTongue[] = [];
  editedTongue: SimpleTongueDto;

  constructor(
    private appService: AppService,
    private msgService: MessageService
  ) { }

  ngOnInit(): void {
    this.init();
    this.reset();
  }

  async init(): Promise<void> {
    this.appService.setBlock(true);
    this.typeOptions = [
      {label: 'Shape', value: 1},
      {label: 'Color', value: 2},
      {label: 'Coating', value: 3}
    ];
    for (const type of this.typeOptions) {
      const data = {
        type: type.value,
        includeIcon: 1,
        includeCount: 0
      };
      this.tongues[type.value] = await firstValueFrom(this.appService.getWithType<SimpleTongueDto[]>('data', 'getSimpleTongues', data));
    }
    this.appService.setBlock(false);
  }

  reset(): void {
    this.selectedTongue = [...this.patientCase.tongues];
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  update(next: boolean): void {
    const newCase: JsonCase = JSON.parse(JSON.stringify(this.patientCase));
    newCase.tongues = this.selectedTongue;
    newCase.tongues.forEach(tongue => tongue.tagger = this.Tagger);
    console.log('newCase', newCase);
    this.appService.postBody('data', 'updateCaseTongue', JSON.stringify(newCase), ContentType.json).subscribe((res: JsonCase) => {
      this.msgService.add(new ToastMsg(SeverityEnum.success, 'Succeed to update tongue tags', ''));
      if (next) {
        this.onUpdateAndNext.emit(res);
      } else {
        this.onUpdate.emit(res);
      }
    });
  }

  get Tagger() {
    return {
      id: this.appService.loginInfo.id,
      name: this.appService.loginInfo.name,
      color: this.appService.loginInfo.color
    }
  }

  cancel(): void {
    this.onCancel.emit();
  }

  hasLocation(tongueType: number): boolean {
    return Utility.hasLocation(tongueType);
  }

  onClickTongueButton(tongue: SimpleTongueDto): void {
    if (this.isTongueSelected(tongue)) {
      this.selectedTongue.splice(this.selectedTongue.findIndex(selected => selected.tongue.id === tongue.id), 1);
    } else {
      if (this.hasLocation(tongue.type)) {
        this.editedTongue = tongue;
        this.tongueLocationSelector.show();
      } else {
        this.selectedTongue.push({
          locations: [],
          tongueType: tongue.type,
          tongue: {
            id: tongue.id,
            name: tongue.name
          },
          tagger: this.Tagger
        });
      }
    }
  }

  onSaveLocation(caseTongue: JsonCaseTongue): void {
    this.selectedTongue.push(caseTongue);
    this.editedTongue = null;
  }

  isTongueSelected(tongue: SimpleTongueDto): boolean {
    return this.selectedTongue.findIndex(selected => selected.tongue.id === tongue.id) !== -1;
  }

  getLocationClass(tongue: SimpleTongueDto, location: number): string {
    const castTongue = this.selectedTongue.find(select => select.tongue.id === tongue.id);
    if (castTongue && castTongue.locations.indexOf(location) !== -1) {
      return 'location-selected';
    } else {
      return 'location-normal';
    }
  }
}
